module.exports = __webpack_public_path__ + "img/arrow-down.1e3ff056.svg";